import '../../scss/acf-blocks/block-accountedge-university.scss';
import tabsNavigation from '../parts/navi-tabs';

const initAccountUniversity = () => {
    tabsNavigation('.js-university-tab-name', '.js-university-tab');
    tabsNavigation('.js-video-tab-name', '.js-video-tab');

    const selectElements = document.querySelectorAll('.js-select-video');
    // Add change event listeners to each select element
    selectElements.forEach(function (selectElement) {
        selectElement.addEventListener('change', function () {
            // Get the selected option value
            const VIDEO_ID = selectElement.value;
            const videoTab = document.querySelector(
                `[data-href="#${VIDEO_ID}"]`
            );
            videoTab && videoTab.click();
        });
    });
};

document.defaultView.addEventListener(
    'DOMContentLoaded',
    initAccountUniversity,
    false
);

// Initialize dynamic block preview (editor).
if (window.acf) {
    window.acf.addAction('render_block_preview', initAccountUniversity);
}
